import { createContext, useContext, type ReactNode } from 'react'

interface HeroImageContextType {
  heroImageSeed?: number | null
}

const HeroImageContext = createContext<HeroImageContextType>({})

export const useHeroImageSeed = () => {
  const context = useContext(HeroImageContext)
  return context.heroImageSeed
}

interface HeroImageProviderProps {
  children: ReactNode
  heroImageSeed?: number | null
}

export function HeroImageProvider({ children, heroImageSeed }: HeroImageProviderProps) {
  return <HeroImageContext.Provider value={{ heroImageSeed }}>{children}</HeroImageContext.Provider>
}
